import React, { Component } from "react";
import { NavLink } from "react-router-dom";
import { withTranslation } from "react-i18next";
import { connect } from "react-redux";
import {
  changeLayout,
  changeLayoutWidth,
  changeSidebarTheme,
  changeSidebarType,
  changePreloader,
} from "../../store/actions";
import withRouter from "../Common/withRouter";

class SidebarContent extends Component {
  constructor(props) {
    super(props);

    const currentPath = props.router.location.pathname;

    this.state = {
      openMasters: this.isPathInMasters(currentPath),
      openAccess: this.isPathInAccess(currentPath),
    };
  }

  componentDidUpdate(prevProps) {
    const prevPath = prevProps.router.location.pathname;
    const currentPath = this.props.router.location.pathname;

    if (prevPath !== currentPath) {
      this.setState({
        openMasters: this.isPathInMasters(currentPath),
        openAccess: this.isPathInAccess(currentPath),
      });
    }
  }

  isPathInMasters = (path) => {
    const mastersPaths = [
      "/role-list",
      "/user-list",
      "/country-list",
      "/state-list",
      "/city-list",
      "/menu-list",
      "/uom-list",
      "/category-list",
      "/material-list",
      "/branch-list",
      "/scrap-reason-list",
    ];
    return mastersPaths.includes(path);
  };

  isPathInAccess = (path) => {
    const accessPaths = ["/menu-access-list"];
    return accessPaths.includes(path);
  };

  toggleMenu = (key, e) => {
    e.preventDefault();
    this.setState((prevState) => ({
      ...prevState,
      [key]: !prevState[key],
    }));
  };

  render() {
    const { t, router } = this.props;
    const { openMasters, openAccess } = this.state;
    const currentPath = router.location.pathname;

    const mastersOpen = openMasters || this.isPathInMasters(currentPath);
    const accessOpen = openAccess || this.isPathInAccess(currentPath);

    const activeClass = ({ isActive }) => (isActive ? "active mm-active" : "");

    return (
      <React.Fragment>
        <div id="sidebar-menu">
          <ul className="metismenu list-unstyled" id="side-menu">
            <li className="menu-title">{t("Menu")}</li>

            {/* Masters */}
            <li className={mastersOpen ? "mm-active" : ""}>
              <a
                href="#"
                className="has-arrow waves-effect"
                onClick={(e) => this.toggleMenu("openMasters", e)}
              >
                <i className="ri-store-2-line"></i>
                <span className="ms-1">{t("Masters")}</span>
              </a>

              <ul
                className={
                  mastersOpen
                    ? "sub-menu mm-collapse mm-show"
                    : "sub-menu mm-collapse"
                }
              >
                <li>
                  <NavLink className={activeClass} to="/role-list">
                    {t("Role Masters")}
                  </NavLink>
                </li>
                <li>
                  <NavLink className={activeClass} to="/user-list">
                    {t("Users Masters")}
                  </NavLink>
                </li>
                <li>
                  <NavLink className={activeClass} to="/country-list">
                    {t("Country Masters")}
                  </NavLink>
                </li>
                <li>
                  <NavLink className={activeClass} to="/state-list">
                    {t("State Masters")}
                  </NavLink>
                </li>
                <li>
                  <NavLink className={activeClass} to="/city-list">
                    {t("City Masters")}
                  </NavLink>
                </li>
                <li>
                  <NavLink className={activeClass} to="/menu-list">
                    {t("Menu Masters")}
                  </NavLink>
                </li>
                <li>
                  <NavLink className={activeClass} to="/uom-list">
                    {t("UOM Masters")}
                  </NavLink>
                </li>
                <li>
                  <NavLink className={activeClass} to="/category-list">
                    {t("Category Masters")}
                  </NavLink>
                </li>
                <li>
                  <NavLink className={activeClass} to="/material-list">
                    {t("Material Masters")}
                  </NavLink>
                </li>
                <li>
                  <NavLink className={activeClass} to="/branch-list">
                    {t("Branch Masters")}
                  </NavLink>
                </li>
                <li>
                  <NavLink className={activeClass} to="/scrap-reason-list">
                    {t("Scrap Reason Masters")}
                  </NavLink>
                </li>
              </ul>
            </li>

            {/* Access */}
            <li className={accessOpen ? "mm-active" : ""}>
              <a
                href="#"
                className="has-arrow waves-effect"
                onClick={(e) => this.toggleMenu("openAccess", e)}
              >
                <i className="ri-store-2-line"></i>
                <span className="ms-1">{t("Access")}</span>
              </a>

              <ul
                className={
                  accessOpen
                    ? "sub-menu mm-collapse mm-show"
                    : "sub-menu mm-collapse"
                }
              >
                <li>
                  <NavLink className={activeClass} to="/menu-access-list">
                    {t("Menu Access")}
                  </NavLink>
                </li>
              </ul>
            </li>

            {/* Single Pages */}
            <li>
              <NavLink className={activeClass} to="/material-intakes-list">
                <i className="ri-store-2-line"></i>
                <span className="ms-1">{t("Material Intakes")}</span>
              </NavLink>
            </li>
            <li>
              <NavLink className={activeClass} to="/material-approval">
                <i className="ri-store-2-line"></i>
                <span className="ms-1">{t("Material Approval")}</span>
              </NavLink>
            </li>
            <li>
              <NavLink className={activeClass} to="/job-card-list">
                <i className="ri-store-2-line"></i>
                <span className="ms-1">{t("Job Card")}</span>
              </NavLink>
            </li>
            <li>
              <NavLink className={activeClass} to="/scrap-list">
                <i className="ri-store-2-line"></i>
                <span className="ms-1">{t("Scrap")}</span>
              </NavLink>
            </li>
            <li>
              <NavLink className={activeClass} to="/spare-part-requests-list">
                <i className="ri-store-2-line"></i>
                <span className="ms-1">{t("Spare Part Requests")}</span>
              </NavLink>
            </li>
            <li>
              <NavLink className={activeClass} to="/spare-part-issues-list">
                <i className="ri-store-2-line"></i>
                <span className="ms-1">{t("Spare Part Issues")}</span>
              </NavLink>
            </li>
          </ul>
        </div>
      </React.Fragment>
    );
  }
}

const mapStatetoProps = (state) => ({ ...state.Layout });

export default withRouter(
  connect(mapStatetoProps, {
    changeLayout,
    changeSidebarTheme,
    changeSidebarType,
    changeLayoutWidth,
    changePreloader,
  })(withTranslation()(SidebarContent))
);
